module.exports = {"370103002":"大观园街道","370103003":"杆石桥街道","370103004":"四里村街道","370103006":"魏家庄街道","370103008":"二七街道","370103009":"七里山街道","370103010":"六里山街道","370103012":"舜玉路街道","370103014":"泺源街道","370103015":"王官庄街道","370103016":"舜耕街道","370103017":"白马山街道","370103018":"七贤街道","370103019":"十六里河街道","370103020":"兴隆街道","370103021":"党家街道","370103022":"陡沟街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370103.json
// module id = 1251
// module chunks = 0